import {useEffect} from 'react';

import {createThread} from './store/actions';
import {useActiveThreadLoadState, useAgentChatDispatch} from './store/context';

/** Starts a fresh draft when the selected thread no longer exists. */
export function useFallbackFromMissingThread(): void {
  const dispatch = useAgentChatDispatch();
  const {failure} = useActiveThreadLoadState();

  useEffect(() => {
    if (failure?.kind === 'not-found') {
      dispatch(createThread());
    }
  }, [dispatch, failure]);
}
